import React from 'react'
import { useOutlet } from 'react-router-dom'

import { SbpPaymentsFilters } from './sbp-payments-filters'
import { SbpPaymentsTable } from './sbp-payments-table'

export const SbpPaymentsPage = (): React.ReactElement => {
  const outlet = useOutlet()
  if (outlet) return outlet

  return (
    <>
      <SbpPaymentsFilters />
      <SbpPaymentsTable />
    </>
  )
}
